import { Address } from 'viem';

import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';

export interface IPoolUploadAuth {
  poolAddress: string;
  timestamp: number;
  signature: string;
}

// Message template MUST match the backend byte-for-byte
// (see matchain-bff-gateway cmd/main.go: uploadAuthMessage).
function buildMessage(poolAddress: string, timestamp: number): string {
  return `Matchain pool logo upload\nPool: ${poolAddress.toLowerCase()}\nTimestamp: ${timestamp}`;
}

/**
 * Asks the connected wallet to sign a short-lived message proving it controls
 * `poolAddress`. The backend recovers the signer and checks it owns the pool's
 * PoolOwnership NFT before proxying the upload to Pinata.
 */
export async function signPoolUploadAuth(
  poolAddress: Address,
): Promise<IPoolUploadAuth> {
  const walletClient = getWalletClient();
  const account = asAddress(walletClient.account?.address);

  const timestamp = Math.floor(Date.now() / 1000);
  const message = buildMessage(poolAddress, timestamp);

  const signature = await walletClient.signMessage({ account, message });

  return { poolAddress, timestamp, signature };
}
